/* tslint:disable */
/* eslint-disable */
/**
 * Finastic Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CountryCode,
    CountryCodeFromJSON,
    CountryCodeFromJSONTyped,
    CountryCodeToJSON,
} from './CountryCode';
import {
    InstalmentDto,
    InstalmentDtoFromJSON,
    InstalmentDtoFromJSONTyped,
    InstalmentDtoToJSON,
} from './InstalmentDto';

/**
 * 
 * @export
 * @interface LinkPaymentDebtDto
 */
export interface LinkPaymentDebtDto {
    /**
     * 
     * @type {CountryCode}
     * @memberof LinkPaymentDebtDto
     */
    countryCode?: CountryCode;
    /**
     * 
     * @type {string}
     * @memberof LinkPaymentDebtDto
     */
    debtId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LinkPaymentDebtDto
     */
    creditorName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LinkPaymentDebtDto
     */
    currencyCode?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LinkPaymentDebtDto
     */
    outstandingBalance?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LinkPaymentDebtDto
     */
    hasInstalmentPlan?: boolean;
    /**
     * 
     * @type {InstalmentDto}
     * @memberof LinkPaymentDebtDto
     */
    nextInstalment?: InstalmentDto;
    /**
     * 
     * @type {number}
     * @memberof LinkPaymentDebtDto
     */
    nextPaymentAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LinkPaymentDebtDto
     */
    isPaymentInProgress?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LinkPaymentDebtDto
     */
    payPointBarcode?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LinkPaymentDebtDto
     */
    isFinasticUser?: boolean;
}

export function LinkPaymentDebtDtoFromJSON(json: any): LinkPaymentDebtDto {
    return LinkPaymentDebtDtoFromJSONTyped(json, false);
}

export function LinkPaymentDebtDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkPaymentDebtDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'countryCode': !exists(json, 'countryCode') ? undefined : CountryCodeFromJSON(json['countryCode']),
        'debtId': !exists(json, 'debtId') ? undefined : json['debtId'],
        'creditorName': !exists(json, 'creditorName') ? undefined : json['creditorName'],
        'currencyCode': !exists(json, 'currencyCode') ? undefined : json['currencyCode'],
        'outstandingBalance': !exists(json, 'outstandingBalance') ? undefined : json['outstandingBalance'],
        'hasInstalmentPlan': !exists(json, 'hasInstalmentPlan') ? undefined : json['hasInstalmentPlan'],
        'nextInstalment': !exists(json, 'nextInstalment') ? undefined : InstalmentDtoFromJSON(json['nextInstalment']),
        'nextPaymentAmount': !exists(json, 'nextPaymentAmount') ? undefined : json['nextPaymentAmount'],
        'isPaymentInProgress': !exists(json, 'isPaymentInProgress') ? undefined : json['isPaymentInProgress'],
        'payPointBarcode': !exists(json, 'payPointBarcode') ? undefined : json['payPointBarcode'],
        'isFinasticUser': !exists(json, 'isFinasticUser') ? undefined : json['isFinasticUser'],
    };
}

export function LinkPaymentDebtDtoToJSON(value?: LinkPaymentDebtDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'countryCode': CountryCodeToJSON(value.countryCode),
        'debtId': value.debtId,
        'creditorName': value.creditorName,
        'currencyCode': value.currencyCode,
        'outstandingBalance': value.outstandingBalance,
        'hasInstalmentPlan': value.hasInstalmentPlan,
        'nextInstalment': InstalmentDtoToJSON(value.nextInstalment),
        'nextPaymentAmount': value.nextPaymentAmount,
        'isPaymentInProgress': value.isPaymentInProgress,
        'payPointBarcode': value.payPointBarcode,
        'isFinasticUser': value.isFinasticUser,
    };
}

